import type { CoreApiClient } from "../client";
import { createMultisensorQueries } from "../queries/multisensor.queries";

export const createMultisensorRepository = (api: CoreApiClient) => ({
  ...createMultisensorQueries(api),
});
